import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _get from 'lodash/get';
import Typography from '@material-ui/core/Typography';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import PageContext from '../PageContext';

const useStyles = makeStyles(theme => ({
  title: {
    color: props => props.introColor || '#fff',
    lineHeight: 1.3,
    marginBottom: 17,
    fontSize: props => props.fontSize || 40,
    fontFamily: 'PoppinsSemiBold',
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'keep-all',
    [theme.breakpoints.down('1140')]: {
      fontSize: 30,
    },
  },
  subTitle: {
    color: props => props.introColor || '#fff',
    lineHeight: 1.5,
    marginBottom: 17,
    fontSize: 17,
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  intro: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    marginBottom: 17,
    '& *': {
      color: props => props.introColor || '#fff',
    },
    '& p': {
      ...theme.typography.body2,
      margin: 0,
      color: props => props.introColor || '#fff',
      minHeight: 0,
    },
    '& ul': {
      listStyleType: 'none',
      padding: 0,
      margin: 0,
    },
    '& a': {
      color: props => props.introColor || '#fff',
    },
  },
}));

function Intro({ fontSize }) {
  const { clientInfo, textColor } = useContext(PageContext);
  const { pageText, fontColor, intro } = clientInfo;
  const introColor = _get(pageText, 'hero.introColor') || fontColor;
  const classes = useStyles({
    introColor: introColor ? `#${introColor}` : textColor,
    fontSize,
  });
  const introTitle = _get(pageText, 'hero.header');
  const subTitle = _get(pageText, 'hero.body');
  return (
    <div>
      {introTitle && (
        <Grid item xs={12}>
          <Typography className={classes.title}>{introTitle} </Typography>
        </Grid>
      )}
      {intro && !subTitle && (
        <Grid item xs={12} className={classes.intro}>
          <RichTextReactRenderer data={intro.json} type="title" isLandingPage />
        </Grid>
      )}
      {subTitle && !intro && (
        <Grid item xs={12}>
          <Typography className={classes.subTitle}>{subTitle} </Typography>
        </Grid>
      )}
    </div>
  );
}

Intro.propTypes = {
  fontSize: PropTypes.number,
};

export default React.memo(Intro);
